<template>
    <div class="pro_box">
        <div class="top_img">
            <img src="../../../assets/icons/官网首页_slices/details_recr.png" alt="">
            <div class="top_font">
                <div class="font_title">招聘信息</div>
                <div class="font_deputy">Recruitment</div>
            </div>
        </div>
        <div class="tbs_box">
            <div class="button_box" 
                @click="openselect(item)"
                v-for="(item,index) in bottonlist" :key="index">
                <div class="botton_font">{{ item.title }}</div>
                <i class="el-icon-arrow-down icon_box" v-if="item.icon"></i>
                <i class="el-icon-arrow-up icon_box" v-if="!item.icon"></i>
            </div>
        </div>    
        <div class="content_box">
            <template v-if="tableData.length>0">
                <div class="content_item" 
                    v-for="(item,index) of tableData" :key="index">
                    <div class="position">
                        <div class="posi_title">{{item.name}}</div>
                        <div class="posi_city">{{ item.city }}</div>
                    </div>
                    <div class="classification">
                        <div class="item_box" 
                            :key="indexs"
                            v-for="(items,indexs) of item.classification">
                            {{ items }}                  
                        </div>
                    </div>
                    <div class="details">
                        <div class="det_time">
                            <div class="time_title">更新日期：</div>
                            <div>{{ item.now }}</div>
                        </div>
                        <div class="details_botton" @click="see(item)">
                            查看详情
                            <i class="el-icon-arrow-down icon_box" v-if="!item.state"></i>
                            <i class="el-icon-arrow-up icon_box" v-if="item.state"></i>
                        </div>
                    </div>
                    <div v-html="item.info" v-if="item.state" class="info_box"></div>
                    <el-button class="app_button"  v-if="item.state" @click="dialogVisible=true">投递简历</el-button>
                </div>
            </template>
            <template v-if="tableData.length==0">
                <div class="not_data">
                    暂无数据
                </div>
            </template>
        </div>
        <bottomnav :display="true"></bottomnav>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="70%">
            <div class="prompt_box">
                <div class="font_title">申请岗位请将个人简历发送至</div>
                <div class="email">service@xzjxrl.com</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
        <el-drawer
            :visible.sync="drawer"
            size="45%"
            @close="close"
            :with-header="false"
            direction="btt">
            <div class="header_box">
                <div class="close_box" @click="close">取消</div>
                <div class="title_box">{{ brawertitle }}</div>
            </div>
            <template v-if="brawertitle=='职位类型'">
                <div class="posi_item" v-if="position.length>0">
                    <div   
                        @click="clickposi(item)"
                        :class="posiactive==item.id?'posiac':''" 
                        class="posi_item_box" 
                        v-for="(item,index) of position" 
                        :key="index">
                        {{ item.name }}
                    </div>
                </div>
                <div class="posi_item not_data" v-if="position.length==0">
                    暂无数据
                </div>
            </template>
            <template v-if="brawertitle=='工作地点'">
                <div class="posi_item" v-if="location.length>0">
                    <div   
                        @click="clickload(item)"
                        :class="loadactive==item.id?'posiac':''" 
                        class="posi_item_box" 
                        v-for="(item,index) of location" 
                        :key="index">
                        {{ item.name }}
                    </div>
                </div>
                <div class="posi_item not_data" v-if="location.length==0">
                    暂无数据
                </div>
            </template>
        </el-drawer>
    </div>
</template>
<script>
import bottomnav from './bottomnav.vue'
export default{
    components:{
        bottomnav
    },
    data(){
        return{
            position:[],
            posiactive:null,
            location:[],
            loadactive:null,
            tab:[],
            dialogVisible:false,
            tableData: [],
            currentExpandedRow: null,
            bottonlist:[
                {id:1,title:'职位类型',icon:true},
                {id:2,title:'工作地点',icon:true}
            ],
            drawer:false,
            brawertitle:'',
            item:null,
        }
    },
    async created(){
        this.tabsaxios()
       
    },
    mounted(){
       
    },
    methods:{
        see(item){
            for (let i = 0; i < this.tableData.length; i++) {
                if(item.id==this.tableData[i].id){
                    this.tableData[i].state=!this.tableData[i].state
                }else{
                    this.tableData[i].state=false
                }
            }
        },
        openselect(item){
            this.drawer=true
            item.icon=!item.icon
            this.item=item
            if(item.id==1){
                this.brawertitle='职位类型'
            }else{
                this.brawertitle='工作地点'
            }
        },
        tabsaxios(){
            this.$webhttp.get('v1/web/dictionary').then((res)=>{
                if(res.code==200){
                    res.data.forEach((item)=>{
                        if(item.type==1){
                            this.position.push(item)
                        }
                        if(item.type==4){
                            this.location.push(item)
                        }
                    }) 
                    this.position.unshift({id:0,name:'全部'})
                    this.location.unshift({id:0,name:'全部'})
                    this.loadactive=this.location[0].id
                    this.posiactive=this.position[0].id 
                    this.tableaxios(this.posiactive,this.loadactive)
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        tableaxios(type,cityId){
            this.$webhttp.get(`v1/web/hire?type=${type}&cityId=${cityId}`).then((res)=>{
                if(res.code==200){
                    res.data.forEach((item,index,array)=>{
                        array[index].info=item.info.replace(/\n/g,'<br/>')
                        array[index]['state']=false
                        if(item.years=='不限'&&item.education=='不限'){
                            array[index]['classification']=[item.type,item.nature]
                        }else if(item.years=='不限'){
                            array[index]['classification']=[item.type,item.education,item.nature]
                        }else if(item.education=='不限'){
                            array[index]['classification']=[item.type,item.years,item.nature]
                        }else{
                            array[index]['classification']=[item.type,item.years,item.education,item.nature]
                        }
                    })
                  
                    this.tableData=res.data
                    this.drawer=false
                }else{
                    this.$message.error(res.message)
                }   
            })  
                    
        },
        close(){
            this.drawer=false
            this.bottonlist.forEach((it)=>{
                if(it.id==this.item.id){
                    it.icon=true
                }
            })
        },
        clickposi(item){
            this.bottonlist.forEach((it)=>{
                if(it.id==this.item.id){
                    it.icon=!it.icon
                }
            })
            this.posiactive=item.id
            this.tableaxios(this.posiactive,this.loadactive)
        },
        clickload(item){
             this.bottonlist.forEach((it)=>{
                if(it.id==this.item.id){
                    it.icon=!it.icon
                }
            })
            this.loadactive=item.id
            this.tableaxios(this.posiactive,this.loadactive)
        
        },
      
    },
}
</script>
<style lang="less" scoped>
@media (max-width:730px){
    /deep/.highlight {
    background:rgba(2,125,252,0.1);
        color: #101010 !important;
        box-sizing: border-box;
    }
    /deep/ .el-table__body tr.current-row > td {
        background:rgba(2,125,252,0.1);
        color: #101010 !important;
        box-sizing: border-box;

    }

    /deep/.el-table::before{
        height: 0px;
    }
    /deep/.el-table tr{
        color: #101010 !important;
        font-weight: 400;
        font-size: 14px;
        margin-bottom: 5px;
        box-sizing: border-box;
    }
    /deep/.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
        border-bottom: none;    
    }
    /deep/.cell-start {
        box-sizing: border-box;
        border-top: 1px solid #D5D5D5 ;
        border-bottom: 1px solid #D5D5D5  !important;
        border-left: 1px solid #D5D5D5 ;
    }
    /deep/.cell-end {
        box-sizing: border-box;
        border-top: 1px solid #D5D5D5 ;
        border-bottom: 1px solid #D5D5D5  !important;
        border-right: 1px solid #D5D5D5 ;
        border-left: 1px solid #D5D5D5 ;
    }
    /deep/.cell-middle {
        box-sizing: border-box;
        border-top: 1px solid #D5D5D5 ;
        border-bottom: 1px solid #D5D5D5  !important;
    }
    /deep/.el-table__body {  //这行代码为间隔效果！！！
        border-spacing: 0px 2px !important;
        box-sizing: border-box;
    }
    /deep/.el-table td {
        height: 56px;
        box-sizing: border-box;
    }
    /deep/.el-table__cell{
        .el-icon-arrow-down,.el-icon-arrow-up{
            font-weight: bold;
            width: 30px;
            height: 20px;
            line-height: 20px;
            cursor: pointer;
        }
    }
    /deep/.el-table__expanded-cell{
        box-sizing: border-box;
        padding: 0px 39px;
        .expand_font{
            margin-top: 5px;
        }
        
    }

    .prompt_box{
        box-sizing: border-box;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .font_title{
            font-size: 18px;
            box-sizing: border-box;
            margin-bottom: 10px;
            font-weight: bold;
        }
        .email{
            font-weight: bold;
            font-size: 22px;
            color: #101010;
        }
    }
    /deep/.el-drawer__header{
        height: 30px;
        position: relative;
        span{
            text-align: center;
        }
        .el-drawer__close-btn{
            top: 0px;
            left: 10px;
        }
    }
    /deep/.el-drawer__body{
        box-sizing: border-box;
        height: 100%;
        .header_box{
            height: 45px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            box-sizing: border-box;
            .close_box{
                position: absolute;
                left: 10px;
                font-size: 17px;
                font-weight: 400;
                color: #5F5F6B;
                cursor: pointer;
            }
            .title_box{
                font-weight: 400;
                font-size: 19px;
                color: #333333;
            }
        }
        .not_data{
            color: #606060;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .posi_item{
            height: 85%;
            overflow: hidden;
            overflow-y: scroll;
            .posiac{
                background: #027DFC !important;
                color: #FFFFFF !important;
            }
            .posi_item_box:hover{
                background: #027DFC;
                color: #FFFFFF;
            }
            .posi_item_box{
                width: 100%;
                height: 45px;
                background: #FFFFFF;
                padding-left: 30px;
                line-height: 45px;
                font-weight: 400;
                font-size: 14px;
                color: #101010;
                margin-right: 8px;
                box-sizing: border-box;
                cursor: pointer;
            }
        }
    }
    .pro_box{
        width: 100%;
        box-sizing: border-box;
        .top_img{
            width: 100%;
            height: 100px;
            position: relative;
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            .top_font{
                position: absolute;
                left: 50%;
                top: 50%;
                color: #FFFFFF;
                text-align: center;
                transform: translateX(-50%) translateY(-50%);
                .font_title{
                    font-weight: bold;
                    font-size: 16px;
                    color: #FFFFFF;
                    line-height: 24px;
                    text-shadow: 0px 4px 10px rgba(0,0,0,0.1);
                }
                .font_deputy{
                    font-weight: 400;
                    font-size: 10px;
                    color: #FFFFFF;
                    text-shadow: 0px 4px 10px rgba(0,0,0,0.1);
                }
            }
        }
        .content_box{
            width: 100%;
            min-height: 505px;
            box-sizing: border-box;
            user-select: none;
            background: #ECECEC;
            padding: 10px 15px;
            .not_data{
                color: #606060;
                width: 100%;
                min-height: 505px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .content_item{
                width: 100%;
                box-sizing: border-box;
                background: #FFFFFF;
                padding: 20px 20px 2px 20px;
                cursor: pointer;
                margin-bottom: 10px;
                .position{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 15px;
                    width: 100%;
                    .posi_title{
                        font-weight: 500;
                        font-size: 17px;
                        color: #101010;
                        width: 90%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        
                    }
                    .posi_city{
                        font-weight: 400;
                        font-size: 14px;
                        color: #606060;
                        width: 150px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        text-align: right;
                    }
                }
                .classification{
                    display: flex;
                    margin-bottom: 15px;
                    .item_box{
                        background: #F5F5F5;
                        box-sizing: border-box;
                        padding: 2px 10px;
                        margin-right: 10px;
                        font-size: 14px;
                        color: #606060;
                    }
                }
                .details{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 10px;
                    .det_time{
                        display: flex;
                        color: #606060;
                        font-size: 14px;
                        font-weight: 400;
                    }
                    .details_botton{
                        font-weight: 400;
                        font-size: 16px;
                        color: #027DFC;
                    }
                }
                .app_button{
                    width: 96px;
                    height: 32px;
                    background: #027DFC;
                    font-weight: 500;
                    font-size: 14px;
                    color: #FFFFFF;
                    padding: 0px 0px;
                    margin-bottom: 15px;
                    margin-top: 10px;
                }
            }
        }
    .tbs_box{
            height: 55px;
            box-sizing: border-box;
            width: 100%;
            user-select: none;
            display: flex;
            align-items: center;
            padding-left: 8px;
            .button_box{
                width: 30%;
                height: 35px;
                box-sizing: border-box;
                border: 1px solid #ECECEC;
                display: flex;
                align-items: center;
                justify-content: space-around;
                margin-left: 10px;
                color: #606060;
                .botton_font{
                    font-weight: 400;
                    font-size: 14px;
                }
                .icon_box{
                    font-size: 16px;
                    font-weight: bold;
                }
            }
        }
    }
}
@media (min-width:730px) {
    /deep/.highlight {
        background:rgba(2,125,252,0.1);
        color: #101010 !important;
        box-sizing: border-box;
    }
    /deep/ .el-table__body tr.current-row > td {
        background:rgba(2,125,252,0.1);
        color: #101010 !important;
        box-sizing: border-box;

    }

    /deep/.el-table::before{
        height: 0px;
    }
    /deep/.el-table tr{
        color: #101010 !important;
        font-weight: 400;
        font-size: 14px;
        margin-bottom: 5px;
        box-sizing: border-box;
    }
    /deep/.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
        border-bottom: none;    
    }
    /deep/.cell-start {
        box-sizing: border-box;
        border-top: 1px solid #D5D5D5 ;
        border-bottom: 1px solid #D5D5D5  !important;
        border-left: 1px solid #D5D5D5 ;
    }
    /deep/.cell-end {
        box-sizing: border-box;
        border-top: 1px solid #D5D5D5 ;
        border-bottom: 1px solid #D5D5D5  !important;
        border-right: 1px solid #D5D5D5 ;
        border-left: 1px solid #D5D5D5 ;
    }
    /deep/.cell-middle {
        box-sizing: border-box;
        border-top: 1px solid #D5D5D5 ;
        border-bottom: 1px solid #D5D5D5  !important;
    }
    /deep/.el-table__body {  //这行代码为间隔效果！！！
        border-spacing: 0px 2px !important;
        box-sizing: border-box;
    }
    /deep/.el-table td {
        height: 56px;
        box-sizing: border-box;
    }
    /deep/.el-table__cell{
        .el-icon-arrow-down,.el-icon-arrow-up{
            font-weight: bold;
            width: 30px;
            height: 20px;
            line-height: 20px;
            cursor: pointer;
        }
    }
    /deep/.el-table__expanded-cell{
        box-sizing: border-box;
        padding: 0px 39px;
        .expand_font{
            margin-top: 5px;
        }
    }
    /deep/.el-dialog{
        .el-dialog__header{
            padding: 30px 40px 30px;
            .el-dialog__title{
                font-size: 28px;
            }
            .el-dialog__headerbtn{
                top: 30px;
                right: 30px;
                font-size: 30px;
            }
        }
        .el-dialog__footer{
            padding: 25px 30px 20px;
            .dialog-footer{
                .el-button{
                    font-size: 28px;
                }
            }
        }
    }
    .prompt_box{
        box-sizing: border-box;
        height: 260px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .font_title{
            font-size: 38px;
            box-sizing: border-box;
            margin-bottom: 10px;
            font-weight: bold;
        }
        .email{
            font-weight: bold;
            font-size: 45px;
            color: #101010;
        }
    }
    /deep/.el-drawer__header{
        height: 30px;
        position: relative;
        span{
            text-align: center;
        }
        .el-drawer__close-btn{
            top: 0px;
            left: 10px;
        }
    }
    /deep/.el-drawer__body{
        box-sizing: border-box;
        height: 100%;
        .header_box{
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            box-sizing: border-box;
            .close_box{
                position: absolute;
                left: 40px;
                font-size: 35px;
                font-weight: bold;
                color: #5F5F6B;
                cursor: pointer;
            }
            .title_box{
                font-weight: bold;
                font-size: 45px;
                color: #333333;
            }
        }
        .not_data{
            color: #606060;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 45px;
        }
        .posi_item{
            height: 85%;
            overflow: hidden;
            overflow-y: scroll;
            .posiac{
                background: #027DFC !important;
                color: #FFFFFF !important;
            }
            .posi_item_box:hover{
                background: #027DFC;
                color: #FFFFFF;
            }
            .posi_item_box{
                width: 100%;
                height: 120px;
                background: #FFFFFF;
                padding-left: 55px;
                line-height: 120px;
                font-weight: bold;
                font-size: 45px;
                color: #101010;
                margin-right: 8px;
                box-sizing: border-box;
                cursor: pointer;
            }
        }
    }
    .pro_box{
        width: 100%;
        box-sizing: border-box;
        .top_img{
            width: 100%;
            height: 250px;
            position: relative;
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            .top_font{
                position: absolute;
                left: 50%;
                top: 50%;
                color: #FFFFFF;
                text-align: center;
                transform: translateX(-50%) translateY(-50%);
                .font_title{
                    font-weight: bold;
                    font-size: 38px;
                    color: #FFFFFF;
                    line-height: 60px;
                    text-shadow: 0px 4px 10px rgba(0,0,0,0.1);
                }
                .font_deputy{
                    font-weight: 400;
                    font-size: 36px;
                    color: #FFFFFF;
                    text-shadow: 0px 4px 10px rgba(0,0,0,0.1);
                }
            }
        }
        .content_box{
            width: 100%;
            min-height: 505px;
            box-sizing: border-box;
            user-select: none;
            background: #ECECEC;
            padding: 10px 38px;
            .not_data{
                color: #606060;
                width: 100%;
                min-height: 1200px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 45px;
                font-weight: bold;
            }
            .content_item{
                width: 100%;
                box-sizing: border-box;
                background: #FFFFFF;
                padding: 45px 45px 20px 45px;
                cursor: pointer;
                margin-bottom: 30px;
                margin-top: 20px;
                .position{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 35px;
                    width: 100%;
                    .posi_title{
                        font-weight: bold;
                        font-size: 38px;
                        color: #101010;
                        width: 90%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .posi_city{
                        font-weight: 400;
                        font-size: 26px;
                        color: #606060;
                        width: 150px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        text-align: right;
                    }
                }
                .classification{
                    display: flex;
                    margin-bottom: 30px;
                    .item_box{
                        background: #F5F5F5;
                        box-sizing: border-box;
                        padding: 12px 22px;
                        margin-right: 20px;
                        font-size: 28px;
                        color: #606060;
                    }
                }
                .details{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 40px;
                    .det_time{
                        display: flex;
                        color: #606060;
                        font-size: 28px;
                        font-weight: 400;
                    }
                    .details_botton{
                        font-weight: 400;
                        font-size: 32px;
                        color: #027DFC;
                    }
                }
                .info_box{
                    font-size: 36px;
                }
                .app_button{
                    width: 245px;
                    height: 65px;
                    line-height: 65px;
                    background: #027DFC;
                    font-weight: 500;
                    font-size: 26px;
                    color: #FFFFFF;
                    padding: 0px 0px;
                    margin-bottom: 45px;
                    margin-top: 30px;
                }
            }
        }
        .tbs_box{
            height: 128px;
            box-sizing: border-box;
            width: 100%;
            user-select: none;
            display: flex;
            align-items: center;
            padding-left: 8px;
            .button_box{
                width: 25%;
                height: 80px;
                box-sizing: border-box;
                border: 5px solid #ECECEC;
                display: flex;
                align-items: center;
                justify-content: space-around;
                margin-left: 30px;
                color: #606060;
                .botton_font{
                    font-weight: 400;
                    font-size: 28px;
                }
                .icon_box{
                    font-size: 28px;
                    font-weight: bold;
                }
            }
        }
    }
}
</style>